import Floor from "../Floor.js";
import Building from "../../Building/Building.js";
import {gsap} from "gsap";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";

const FloorBuilding = {

    init() {
        this.el = $('[component="FloorBuilding"]');
        if (!this.el.length) return;

        this.floors = this.el.find('svg path');
        this.number = this.el.find('.number');
        this.isResidendeBuilding = this.el.hasClass("residence");

        this.Bubble.init(this.el);
        this.bind();
    },

    bind() {
        this.floors.click((evt) => {
            this.onClick(evt);
        })

        this.floors.mouseenter((evt) => {
            this.onEnter(evt);
        })

        this.floors.mouseleave((evt) => {
            this.onLeave(evt);
        })
    },

    setActive(nmb) {
        const floor = this.floors.filter('[id="' + nmb + '"]');
        floor.addClass('active').siblings().removeClass('active');
        const top = floor.offset().top - FloorBuilding.el.offset().top;
        this.number.text(nmb === 0 ? '' : nmb);
        gsap.to(this.number, {top: top, opacity: 1, duration: 0.5});
        this.Bubble.hide();
    },

    onClick(evt) {
        const nmb = parseInt($(evt.currentTarget).attr('id'));
        const direction = Math.sign(nmb - Floor.number);

        if (this.isResidendeBuilding && nmb <= 1) {
            return;
        }

        Floor.number = nmb;
        NavigatorRouter.setFloor(nmb, direction);
        NavigatorRouter.setSpace(null);
    },

    onEnter(evt) {
        const floor = evt.currentTarget;
        $(floor).addClass('hover').siblings().removeClass('hover');
        this.Bubble.show(floor, evt);
        gsap.to(this.number, {opacity: 0, duration: 0.5});
        this.isHiding = false;
    },

    onLeave(evt) {
        const floor = evt.currentTarget;
        $(floor).removeClass('hover')
        gsap.to(this.number, {opacity: 1, duration: 0.5});
        this.isHiding = true;

        setTimeout(() => {
            if (this.isHiding) {
                this.Bubble.hide();
            }
        }, 300)
    },

    Bubble: {
        init(el) {
            this.el = el.find('.bubble');
        },

        show(floor, evt) {
            const number = parseInt($(floor).attr('id'));
            this.data = Building.data.floors[number];
            const bubbleH = floor.getBoundingClientRect().height / 2;
            const posY = evt.clientY - FloorBuilding.el.offset().top - bubbleH + window.scrollY;
            gsap.to(this.el, {top: posY, duration: 0.2});
            this.set();
        },

        set() {
            switch (this.data.type) {
                case 'flat': {
                    this.data.title = this.data.number + '&nbsp;podlažie';
                    this.el.removeClass('shop medical');
                    break;
                }
                case 'apartment': {
                    this.data.title = this.data.number + '&nbsp;podlažie';
                    this.el.removeClass('shop medical');
                    break;
                }
                case 'shop': {
                    this.data.title = 'Obchodné<br>priestory';
                    this.el.addClass('shop');
                    break;
                }
                case 'medical': {
                    this.data.title = 'Zdravotnícke<br>zariadenie';
                    this.el.addClass('medical');
                    break;
                }
            }
            this.el.find('.floor').html(this.data.title);
            this.el.find('.free').html(this.inflect());
            this.el.toggleClass('empty', this.data.flats_free === 0);
            gsap.to(this.el, {opacity: 1, duration: 0.2});
        },

        hide() {
            gsap.to(this.el, {opacity: 0, duration: 0.5});
        },

        inflect() {
            const free = this.data.flats_free;

            if (free === 0) {
                return '0 voľných';
            } else if (free === 1) {
                return '1 voľný';
            } else if (free >= 2 && free <= 4) {
                return free + ' voľné';
            }
        },
    }

}

export default FloorBuilding;